import { useState, useCallback } from 'react'
import ReactDOM from 'react-dom'
import { message as $message } from 'antd'
import { getWeChatCodeUrl, getWeChatCodeUrlOpen } from '@/services/workweixin'
import { getToken } from '@/utils/token'

const QR_WIDTH = 430

interface useMobileVisitorManageQR {
    mobileVisitorManageQRUrl: string
    loadingMobileVisitorManageQRUrl: boolean,
    // 扫码看数据二维码
    getMobileVisitorManageQRUrl: () => void
    // 获取扫码看数据二维码
}

// 只存一份如果尺寸不一致建议另外请求生成
export default (): useMobileVisitorManageQR => {
    const [mobileVisitorManageQRUrl, setMobileVisitorManageQRUrl] = useState('')
    const [loadingMobileVisitorManageQRUrl, setLoadingMobileVisitorManageQRUrl] = useState(true)

    const getMobileVisitorManageQRUrl = useCallback(async () => {
        const api = getToken() ? getWeChatCodeUrl : getWeChatCodeUrlOpen
        setLoadingMobileVisitorManageQRUrl(true)
        const { data, message, success } = await api({
            width: QR_WIDTH,
            page: 'pages/supplier/home/index',
            scene: 'from=pc',
        })
        if (success) {
            ReactDOM.unstable_batchedUpdates(() => {
                setLoadingMobileVisitorManageQRUrl(false)
                setMobileVisitorManageQRUrl(data)
            })
        } else {
            $message.error(message)
        }
    }, [])
    
    return { loadingMobileVisitorManageQRUrl, mobileVisitorManageQRUrl, getMobileVisitorManageQRUrl }
}
